import { createTheme } from '@mui/material/styles';
import {grey} from "@mui/material/colors";

const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', Arial, sans-serif",
    h1: {
      fontSize: "clamp(2rem, 5vw, 3rem)",
      fontWeight: 700,
    },
    h2: {
      fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
      fontWeight: 600,
    },
    h3: {
      fontSize: "clamp(1.4rem, 3.5vw, 2rem)",
      fontWeight: 600,
    },
    h4: {
      fontSize: "clamp(1.25rem, 3vw, 1.5rem)",
      fontWeight: 500,
    },
    h5: {
      fontSize: "clamp(1.1rem, 2.5vw, 1.25rem)",
      fontWeight: 500,
    },
    h6: {
      fontSize: "clamp(1rem, 2vw, 1.125rem)",
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 300,
      fontStyle: "normal",
      lineHeight: 1.5,
    },
    body2: {
      fontSize: "0.875rem", // Smaller text (e.g., captions)
    },
  },
  palette: {
    primary: {
      main: '#7A3AFD',
      secondary: '#9C6CFF',
      tertiary: '#DAC9FF',
      grey: '#F1F1F1'
    },
    secondary: {
      main: '#3F83A6',
      secondary: '#C6E8F0',
      tertiary: '#F8CEB0',
      grey: '#F1F1F1'
    },
    tertiary: {
      main: '#3368DC',
      secondary: '#3368DC',
      tertiary: '#6CB0FF',
      grey: '#F1F1F1'
    },
    darkGrey: {
      main: '#393939',
      secondary: '#606064',
      tertiary: '#B2ADAD'
    },
    lightGrey: {
      main: '#F1F1F1',
      secondary: grey["50"],
    },
  },
  mixins: {
    MuiDataGrid: {
      // Pinned columns sections
      pinnedBackground: '#DAC9FF',
      // Headers, and top & bottom fixed rows
      containerBackground: '#9C6CFF'
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: (props) => {
          const hasValue = props.ownerState.formControl?.filled === true; // filled or not
          return {
            maxWidth: `calc(100% - ${props.ownerState.focused || hasValue ? 0 : 60}px)`,
          };
        },
      },
    },
  },
});

export default theme;
